export default __webpack_public_path__ + "static/media/bhakti.5bc19aca.png";